<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15IAGA1/tc-custom/9780062839312.jpg?1716663320565" alt="This image is the cover for the book Lands of Lost Borders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lands of Lost Borders
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman recounts her life-changing bicycling journey along the Silk Road in this award-winning travelogue and memoir.</b><br/><br/>As a teenager, Kate Harris wanted to be an explorer, equal parts swashbuckler and metaphysician. With the Earth already mapped by the likes of Magellan and Marco Polo, she set her sights on the stars: she would become a scientist and go to Mars. But in between studying at Oxford and MIT, she set off by bicycle with a childhood friend down the fabled Silk Road, where, pedaling mile upon mile through some of the remotest places, she realized that exploration—in any day or age—is the refusal to live between the lines. Forget charting maps, naming peaks: what she yearned for was the feeling of soaring completely out of bounds. The farther she traveled, the closer she came to a world as wild as she felt within.<br/><br/><i>Lands of Lost Borders</i> is the chronicle of Harris’s odyssey and an exploration of the importance of breaking the boundaries we set ourselves; an examination of the stories borders tell, and the restrictions they place on nature and humanity; and a meditation on the existential need to explore—the essential longing to discover what in the universe we are doing here. Harris ponders the nature of limits and the wildness of the self that can never fully be mapped. Weaving adventure and philosophy with the history of science and exploration, her intimate, mind-expanding travelogue celebrates our connection as humans to the natural world, and ultimately to each other—a belonging that transcends any fences or stories that may divide us.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Harris
      </h2>
      
      <p class="authorDescription body article"><P>Kate Harris is a writer and adventurer with a knack for getting lost. Named one of Canada's top modern-day explorers, her award-winning nature and travel writing has featured in <I>The Walrus</I>, <I>Canadian Geographic Travel</I>, <I>Sidetracked</I> and <I>The Georgia Review</I>, and cited in <I>Best American Essays </I>and <I>Best American</I><I>Travel Writing</I>. In 2019, she was awarded the RBC Taylor Prize, one of Canada's most esteemed literature awards. She has degrees in science from MIT and the University of North Carolina at Chapel Hill, and in the history of science from Oxford, where she studied as a Rhodes scholar. When she isn't away on expeditions, or reporting on UN environmental negotiations for the International Institute for Sustainable Development, Harris lives off-grid in a log cabin on the border of the Yukon, British Columbia and Alaska. This is her first book.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?af057036